













import { Watch, Component, Prop, Vue } from 'vue-property-decorator';
import { ToneConfig } from './../type/ToneConfig';

// components
import NavTitle from './NavTitle.vue';

@Component
export default class MusicItem extends Vue {
  // 宣告 DOM 型別
  public $refs!: {
    audio: HTMLMediaElement;
  };

  isPlaying: boolean | null = null;

  @Prop({ required: true }) private music!: ToneConfig;
  @Prop() private status!: string;

  get _selecting(): string {
    return this.$store.state[`_${this.status}`];
  }

  set _selecting(val) {
    this.$store.commit('CHANGE_TONE', {
      val,
      key: `_${this.status}`
    })
  }

  musicPlayHandler() {
    const audio: HTMLMediaElement = this.$refs.audio;
    audio.currentTime = 0;
    if (audio.paused) {
      audio.play();
      this.isPlaying = true;
      return;
    }
    audio.pause();
    this.isPlaying = false;
  }

  audioEndHandler() {
    this.isPlaying = false;
  }

}
